import styled from 'styled-components';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { Columns } from '../base/grid';
import RichText from '../base/richText';

export const ImageCtaWrapper = styled.div`
	margin-top: 150px;
`;

export const CardContainerWrapper = styled.div`
	box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.08);
	border-radius: 16px;
	background-color: ${theme.colors.white};
	padding-top: 16px;
	padding-bottom: 16px;

	${media.desktopSmall`
		padding-top: 24px;
		padding-bottom: 24px;
	`}
`;

export const TextWrapper = styled.div`
	margin-top: 48px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	height: 100%;

	${media.desktopSmall`
		margin-top: 0;
	`}
`;

export const DescriptionRichText = styled(RichText)`
	margin-top: 24px;
`;

export const ButtonWrapper = styled.div`
	display: flex;
	margin-top: 48px;
`;

interface CardImageWrapperProps {
	imageOnLeft?: boolean;
  }

export const CardImageWrapper = styled.div<CardImageWrapperProps>`
	display: flex;
	justify-content: flex-start;

	${media.desktopSmall`
		margin-right: ${({ imageOnLeft }) => (imageOnLeft ? '0' : '-40px')};
		margin-left: ${({ imageOnLeft }) => (imageOnLeft ? '-40px' : '0')};
		justify-content: flex-end;
	`}

	${media.desktopLarge`
		margin-right: -96px;
	`}
`;

export const Image = styled.img`
	height: 100%;
	max-width: 100%;
	border-radius: 16px;
`;

export const NonCardImage = styled(Image)`
	max-height: 550px;
`;

export const CardImage = styled(Image)`
	max-height: 550px;

	${media.desktopSmall`
		max-height: 680px;
	`}
`;

export const ColumnImageWrapper = styled.div`
	display: flex;
	justify-content: flex-start;

	${media.desktopSmall`
		justify-content: flex-end;
	`}
`;

export const ImageWrapper = styled.div`
	display: inline-flex;
	position: relative;
`;

export const SmallImageWrapper = styled.span`
	position: absolute;
	bottom: 0;
	right: 0;
	display: flex;
	transform: translate(10%, 25%);

	${media.desktopSmall`
		right: auto;
		left: 0;
		transform: translate(-50%, 25%);
	`}

	${media.desktopLarge`
		transform: translate(-65%, 25%);
	`}

    svg {
		width: auto;
		height: auto;
		max-width: 300px;
		max-height: 100px;

		${media.tablet`
            max-height: 150px;
        `}

		${media.desktopSmall`
            max-height: 130px;
        `}

        ${media.desktopLarge`
            max-height: 200px;
        `}
	}
`;

interface ColumnsStyledProps {
	smallIconAvailable?: boolean;
	imageOnLeft?: boolean;
}

export const ColumnsStyled = styled(Columns)<ColumnsStyledProps>`
	margin-bottom: 0;
	flex-direction: column-reverse;

	${media.desktopSmall`
	  flex-direction: ${({ imageOnLeft }) => (imageOnLeft ? 'row-reverse' : 'row')};
    justify-content: space-between;
    padding-bottom: ${({ smallIconAvailable }) => smallIconAvailable && '32px'};
    `}
`;
